import { parseISO } from 'date-fns';
import { getToday } from './getToday';

export function getTodayISO() {
  return parseISO(getToday());
}
